import { Grid, useEventCallback } from '@mui/material';
import { Fragment, memo } from 'react';
import { AllegatoAtti, DocumentVM } from 'civil-status/view-models/step-form';
import { HttpResponse } from 'shell/models/http-response';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { downloadBlob } from 'front-office/utils/download-blob';
import { base64ToBlobPdf } from 'shell/utils/base64-to-blob';

interface FormProps {
  values?: DocumentVM;
}

const FormComponent = ({ values }: FormProps): React.ReactElement => {
  const getDocument = useHttpClient(``, {
    options: {
      method: 'POST',
    },
  });

  const onClickLink = useEventCallback((idAnscAllegato) => {
    (
      getDocument({
        url: `${__ACT_API_URL__}/gestione-allegato-atti/ricerca-ansc`,
        data: {
          listaAllegatoAtti: [{ idAnscAllegato }],
        },
      }) as ResponsePromise<HttpResponse<{ listaAllegatoAtti: Array<AllegatoAtti> }>>
    ).then((response) => {
      const castedResponse = response?.data?.payload?.listaAllegatoAtti || [];

      const raw = castedResponse[0]?.oggettoAllegato || '';
      const name = castedResponse[0]?.nomeFile || '';

      if (raw) {
        // scaricare file
        const blob = base64ToBlobPdf(raw);
        downloadBlob(blob, name);
      }
    });
  });

  return (
    <Fragment>
      <Grid item container spacing={2} xs={12}>
        {(values?.files || [])?.map((itemFile) => (
          <Grid container spacing={2} item xs={12} key={`${itemFile.name}-${itemFile.idAllegato}`}>
            <Grid item xs={12}>
              <span
                style={{ color: '-webkit-link', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => onClickLink(itemFile.idAllegato)}
              >
                {itemFile.name}
              </span>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Fragment>
  );
};

FormComponent.displayName = 'Form Document from ANSC';

const Form = memo(FormComponent);

export default Form;
